<template>
  <FlotoAnchorLink :aria-label="$tc('resolve')" @click="triggerAction">
    <MIcon name="check-circle" class="action-menu-icon" />
    <span class="ml-1 action-menu-text"> {{ $tc('resolve') }} </span>
    <FlotoConfirmModal
      :open="showModal"
      prevent-auto-redolve-on-confirm
      :processing="processing"
      @hide="showModal = false"
      @confirm="handleConfirmAction"
    >
      <template v-slot:icon>
        <MIcon
          name="check-circle"
          class="w-full text-secondary-green"
          size="2x"
        />
      </template>
      <template v-slot:message>
        {{
          $t('confirm_resolve', {
            resource: $tc(moduleName),
          })
        }}
      </template>
    </FlotoConfirmModal>
  </FlotoAnchorLink>
</template>

<script>
export default {
  name: 'Resolve',
  props: {
    moduleName: { type: String, required: true },
    handleResolveRequests: { type: Function, default: undefined },
  },
  data() {
    return {
      showModal: false,
      processing: false,
    }
  },
  methods: {
    handleConfirmAction() {
      this.$emit('done')
      if (this.handleResolveRequests) {
        this.processing = true
        this.handleResolveRequests()
          .then(() => {
            this.showModal = false
          })
          .finally(() => (this.processing = false))
      } else {
        this.showModal = false
      }
    },
    triggerAction() {
      this.$emit('trigger')
      // show modal after dropdown is hide
      setTimeout(() => {
        this.showModal = true
      }, 400)
    },
  },
}
</script>
